// extracted by mini-css-extract-plugin
export default {"landscapeUpdatesWrapper":"LandscapeUpdatesPage_landscapeUpdatesWrapper__aj-KD"};